import store from "../store";
import jwt_decode from "jwt-decode";

export default function vendor_notcomplete({ next, router }) {
    // let token_expiration = null;
    (async function () {
        const token = localStorage.getItem('token')
        const access_token = jwt_decode(token)
        await store.dispatch('userDetail', access_token.user_id)
        if (store.getters.userFieldStatus && access_token.user === 'vendor_robot') {
            return router.push({ name: 'UpdateProfile', params: { id: store.getters.user.id } }).catch(()=> {});
        }
    })()
    
    return next();
}